export default class Funcionario {
    constructor() {
        this.id = null;
        this.nome = null;       
        this.dataNascimento = new Date();  
        this.dataAdmissao = new Date();     
        this.dataAtivacao = new Date();
        this.cracha = null;
        this.registro = null;
        this.senhaTecladoSemBio = null;
        this.pis = null; 
        this.cpf = null;       
        this.email = null;
        this.nomeCurto = null;
        this.duplaVerificacao = false;
        this.fotoPerfil = 'perfilsemfoto.png';
        this.agendarAtivacao = false;
    }    
}